import React from "react";
import { pluralize } from "@common/helpers/string";
import { useChartOfAccountsQuery } from "@api/accountingReports.api";
import { countSelectedAccountRows } from "../Tabs/CatalogItemLedgerAccountFilter/catalogItemLedgerAccountSelection";

interface Props {
    accountIds?: string[];
    entityIds?: number[];
}

export const CatalogItemLedgerAccountFilterLabel: React.FC<Props> = ({
    accountIds,
    entityIds,
}) => {
    const { data: chartOfAccounts } = useChartOfAccountsQuery();

    if (!accountIds?.length) {
        return null;
    }

    const count = countSelectedAccountRows({
        accountIds,
        accounts: chartOfAccounts?.accounts,
        groups: chartOfAccounts?.groups,
        entityIds,
    });

    return (
        <>
            {count} {pluralize("Account", count)}
        </>
    );
};
